import moment from 'moment'
import request from 'local_modules/request'
import actions from 'redux/actions'
import { reducers, getState } from 'redux/core'
import { constants, modals } from 'helpers'


const setFetching = (isFetching) => reducers.marketplace.customerSchedulePage.setFetching(isFetching)

const setStep = (step) => reducers.marketplace.customerSchedulePage.setStep(step)

const setStepData = (stepData) => reducers.marketplace.customerSchedulePage.setStepData(stepData)

const fetchLabels = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.tariffLabels + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => {
      reducers.marketplace.customerSchedulePage.setLabels(data)
      setFetching(false)
    })
    .catch((error) => console.log(error))
}

const fetchSchedule = ({ year, month }) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.generateSchedule + `/${year}/${month}/${tool}`)
    .then(({ data }) => data)
    .then((data) => data.map(({ day, sessions }) => ({
      day: moment(day, 'YYYY-MM-DD').format('DD.MM.YYYY'),
      sessions,
    })))
    .then((data) => reducers.marketplace.customerSchedulePage.updateSchedule(data))
    .catch((error) => console.log(error))
}

const fetchTariffs = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.tariff + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.customerSchedulePage.setTariffs(data))
}

const clearTotal = () => {
  reducers.marketplace.customerSchedulePage.setTotalFetching(true)
  reducers.marketplace.customerSchedulePage.setTotal(null)
}

const getSchedules = ({ sessions, services = {} }) => {
  const schedules = []

  Object.keys(sessions).forEach((day) => {
    sessions[day].forEach(({ scheduleId }) => {
      const scheduleServices = ((services[day] && services[day][scheduleId]) || [])
        .map(({ id, count }) => ({ id, count }))

      schedules.push({ id: scheduleId, services: scheduleServices })
    })
  })

  return schedules
}

const fetchTotal = ({ tariff, sessions, services = {} }) => {
  // const { marketplace: { layersNavigation: { tool } } } = getState()

  const schedules = getSchedules({ sessions, services })

  if (!schedules.length) {
    clearTotal()

    return Promise.resolve()
  }

  reducers.marketplace.customerSchedulePage.setTotalFetching(true)

  return request.post(constants.marketplace.bookingTotal, {
    tariffCategory: { id: tariff.id },
    schedules,
  })
    .then(({ data }) => data)
    .then(({ total }) => {
      reducers.marketplace.customerSchedulePage.setTotal(total)
      reducers.marketplace.customerSchedulePage.setTotalFetching(false)
    })
}

const fetchCategories = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.statisticsCategories + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.customerSchedulePage.setCategories(data))
    .catch((error) => console.log(error))
}

const fetchServices = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.environmentServices + `/${tool}`)
    .then(({ data }) => data)
    .then((categories) => reducers.marketplace.customerSchedulePage.setServices(categories))
    .catch((error) => console.log(error))
}

const handlePayment = (data) => {
  const { marketplace: { layersNavigation: { category, tool, tools } } } = getState()

  const activeTool  = category === 'sport' && tools.find(({ areas }) => areas.find(({ id }) => id === tool)) || {}
  const isSauna     = activeTool.id === 4

  const {
    tariff,
    selectedSessions, services,
    gender, dateOfBirth, label,
    email,
    phone,
  } = data

  const schedules = getSchedules({ sessions: selectedSessions, services })

  actions.ui.showRequestLoader('Не закрывайте окно, ваш запрос на оплату обрабатывается')

  return request.post(constants.marketplace.booking, {
    tariffCategory: { id: tariff.id },
    schedules,
    subscriber: {
      email,
      // phone, // temporary remove phone field
      gender: gender || 'female',
      label: isSauna ? null : label,
      birthInt: isSauna ? null : {
        y: moment(dateOfBirth, 'DDMMYYYY').format('YYYY'),
        m: moment(dateOfBirth, 'DDMMYYYY').format('MM'),
        d: moment(dateOfBirth, 'DDMMYYYY').format('DD'),
      },
    },
  })
    .then(({ data }) => data)
    .then((data) => {
      const {
        status,
        errormsg,
        redirectUrl,
      } = data || {}

      if (errormsg) {
        actions.ui.hideRequestLoader()
        actions.modals.open(modals.Dialog, {
          title: 'Оплата не прошла',
          text: errormsg,
        })
      }
      else if (redirectUrl) {
        window.location.href = redirectUrl
      }
      else {
        actions.ui.hideRequestLoader()
        console.log(data)
      }

      return data
    })
    .catch((error) => {
      console.log(error)
      actions.ui.hideRequestLoader()
    })
}

const resetSchedule = () => reducers.marketplace.customerSchedulePage.resetSchedule()


export default {
  setFetching,
  setStepData,
  setStep,

  resetSchedule,
  handlePayment,
  fetchCategories,
  fetchServices,
  fetchSchedule,
  fetchTariffs,
  fetchLabels,
  fetchTotal,
  clearTotal,
}
